// |-- Built-in Dependencies --|
import React from "react";

// |-- External Dependencies --|
import { Formik } from "formik";
import { object, string } from "yup";
import Dialog from "@mui/material/Dialog";

// |-- Internal Dependencies --|
import { showToast } from "src/utils/showToaster";
import { useAddDispositionLevelOneMutation } from "src/services/DispositionLevelOneServices";
import DispositionLevelOneForm from "../Layout/DispositionLevelOneForm";

// |-- Types --|
type Props = {
  onClose: () => void;
};

export type FormInitialValues = {
  dispositionFirstName: string;
};
const AddDispositionLevelOneFormWrapper = ({ onClose }: Props) => {
  const [addDispositionLevelOne] = useAddDispositionLevelOneMutation();

  const initialValues: FormInitialValues = {
    dispositionFirstName: "",
  };

  const validationSchema = object({
    dispositionFirstName: string().required(
      "Disposition first name is required"
    ),
  });

  const onSubmitHandler = (values: FormInitialValues) => {
    setTimeout(() => {
      addDispositionLevelOne(values)
        .then((res: any) => {
          if (res?.data?.status) {
            showToast("success", "added successfully!");
            onClose();
          } else {
            showToast("error", res?.data?.message);
            onClose();
          }
        })
        .catch((err) => {
          console.error("error", err);
        });
    }, 1000);
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmitHandler}
      >
        {(formikProps) => {
          return (
            <DispositionLevelOneForm
              formType="Add"
              onClose={onClose}
              formikProps={formikProps}
            />
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default AddDispositionLevelOneFormWrapper;
